import {useNavigation} from '@react-navigation/native';
import * as React from 'react';
import {Platform, View} from 'react-native';
import {useStyles} from '../../../../../../shared/hooks/styles';
import {DeviceSize} from '../../../../../../shared/theme/helpers';
import {ProductCategoryFilterList} from '../../list';
import {ProductsCategoryFilterViewBaseProps} from '../../../model';
import {Text} from '../../../../../../shared/components/text';

export const ProductsCategoryFilterMobile: React.FC<ProductsCategoryFilterViewBaseProps> = ({
  productCategories,
  onSubmit,
}) => {
  const navigation = useNavigation();

  const _handlePressShow = () => {
    onSubmit();
    Platform.OS !== 'web' && navigation.goBack();
  };

  const styles = useStyles(({theme, mediaOnly}) => ({
    container: {
      flexDirection: 'column',
      justifyContent: 'flex-start',
      alignItems: 'stretch',
      paddingTop: Platform.OS === 'web' ? 35 : 0,
      paddingHorizontal: 35,
    },
    filterButtonContainer: {
      marginTop: 5,
      paddingVertical: Platform.OS === 'web' ? 12 : 0,
      paddingHorizontal: 0,
      justifyContent: 'center',
      alignItems: 'center',
      borderTopWidth: 0,
      borderStyle: 'solid',
      borderTopColor: theme.color.borderColor,
    },
    filterButton: mediaOnly(DeviceSize.mobile, {width: '100%'}, {width: 328}),
  }));

  return (
    <View style={styles.container}>
      <View style={{marginBottom: Platform.OS === 'web' ? 25 : 0, alignSelf: 'center'}}>
        <Text type='h4'>Категории</Text>
      </View>
      <ProductCategoryFilterList productCategories={productCategories} />
      <View style={[styles.filterButtonContainer]} />
    </View>
  );
};
